import { Component } from 'vue-property-decorator'
import Vue from 'vue'
import Header from '@/components/header/header'
import Footer from '@/components/footer/footer'

@Component({
  components: {
    Header,
    Footer
  }
})
export default class Error404 extends Vue {
  _goToHome() {
    this.$router.push({ name: 'root' })
  }
}
